module.exports = __webpack_public_path__ + "img/stage4.e34e116a.png";